import { jsx as i } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import g, { css as t } from "styled-components";
const r = {
  SM: "sm",
  LG: "lg"
};
Object.values(r);
const p = g.p.withConfig({
  displayName: "Paragraph",
  componentId: "sc-1yssn8l-0"
})(["color:var(--text-paragraph-color);font-family:var(--font-family-base);font-weight:var(--font-weight-light);letter-spacing:var(--letter-spacing-default);line-height:var(--line-height-lg);margin:0;*{color:inherit;}", " ", ""], ({
  size: a
}) => a === r.LG && t(["font-size:var(--font-size-sm);"]), ({
  size: a
}) => a === r.SM && t(["font-size:var(--font-size-xs);"])), l = s(({
  children: a,
  size: o = r.SM,
  ...e
}, n) => /* @__PURE__ */ i(p, { size: o, ...e, ref: n, "data-testid": "rango-paragraph", "data-rango-component": "rango-paragraph", "data-is-rango": !0, children: a }));
l.displayName = "RangoParagraph";
export {
  r as P,
  l as R
};
